<div class="view-component"  > 
    <!--div class="view-component-title">
      <span class="mat-headline-6" class="title">Cadastro de Anúncios</span>
    </div-->
    <div class="content">
      <div class="tabcontent">
        <marketplace-tabs></marketplace-tabs>
      </div>
    </div>
</div>